import { getCartId } from '@ecomm/data-storage'
import type { D2DCookie } from '@ecomm/door-to-door-constants/cookies'
import { D2DAgentIdCookie } from '@ecomm/door-to-door-constants/cookies'
import { useModalContext } from '@ecomm/modal/lib/ModalContext/useModalContext'
import { Modal } from '@ecomm/shared-components/lib/Modal'
import { getCookie } from '@ecomm/shared-cookies'
import React, { useCallback } from 'react'
import type { SendLinkToCustomerModalProps } from '../SendLinkToCustomerModal'
import { getCheckoutLink } from '../SendLinkToCustomerModal/PhoneEmailCaptureForm/useHandlePhoneEmailFormSubmission'

const QRCodeSVG = React.lazy(() =>
  import('qrcode.react').then(m => ({ default: m.QRCodeSVG }))
)

export function QRCodeModal({
  isOpen,
  onRequestClose,
  sendLinkToCustomerProps
}: {
  readonly isOpen: boolean
  readonly onRequestClose: () => void
  readonly size?: number
  readonly marginSize?: number
  readonly sendLinkToCustomerProps: SendLinkToCustomerModalProps
}) {
  const cartId = getCartId() || ''
  const d2dCookie: D2DCookie = getCookie(D2DAgentIdCookie)
  const agentId = d2dCookie.agentId || ''
  const d2dCheckoutLink = getCheckoutLink(cartId, agentId)

  const { openSendLinkToCustomer } = useModalContext()
  const sendLinkToCustomerModal = useCallback(() => {
    openSendLinkToCustomer(sendLinkToCustomerProps)
  }, [sendLinkToCustomerProps, openSendLinkToCustomer])

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={{ content: { maxWidth: '686px' } }}
    >
      <div
        className="flex max-w-screen-lg flex-col-reverse gap-6 p-8 lg:flex-row prose md:prose-md lg:prose-lg lg:items-center"
        data-testid="qr-code-modal"
      >
        <div className="flex flex-col my-auto flex-1 justify-items-center py-7 px-10 gap-8">
          <div>
            <h3 className="mb-4 font-bold text-center text-3xl">
              Send Checkout Link
            </h3>
            <p className="text-sm gap-1 my-0">
              Ask the customer to scan the QR code to open checkout on their
              device.
            </p>
          </div>
          <React.Suspense
            fallback={<div className="h-4 w-full">Loading...</div>}
          >
            <QRCodeSVG
              className="mx-auto"
              value={d2dCheckoutLink}
              size={256}
              title="QR Code to link to checkout"
            />
          </React.Suspense>
          <button
            className="flex-col p-0 border-0 underline text-sm bg-transparent text-blue-600 hover:cursor-pointer my-0"
            onClick={sendLinkToCustomerModal}
          >
            Send via SMS or Email instead
          </button>
          <button
            className="flex-col text-white w-full px-5 py-4 cursor-pointer border-none bg-btn-primary text-center text-lg font-bold rounded-lg my-0"
            onClick={onRequestClose}
          >
            Done
          </button>
        </div>
      </div>
    </Modal>
  )
}
